import * as React from 'react';
import { ToneCardViewImpl } from '../../featuredcategory/viewmodel/tonecard/tonecardview';
import { DeleteConfirmComponent } from '../../../popup/deleteconfirmation/deleteconfirmationcomponent';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';


export class WishlistToneCardViewImpl extends ToneCardViewImpl
{
  
     showDeleteConfirmationPopUp(id: string)
     {
          let popup = this.getPopUpWrapper();
          popup !== null && popup.setShowWindow(true, 
            <DeleteConfirmComponent msg={this.getContext().getResources().getString(Strings.wishlist_confirm_delete_msg)} id={id}  headerTitle={this.getContext().getResources().getString(Strings.confirm)} closePopup={this.closePopup} context={this.getContext()} onConfirmClick={this.onDeleteConfirmed} onCancelClick={this.closePopup} />);
     }
     
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/wishlist/tones/wishlisttonecardview.tsx